// 3p
import { connect } from 'react-redux';
import { EditorState } from 'draft-js';
import { Link } from 'react-router';
import React from 'react';

// Fp
import { FETCH_PAGE } from '../../constants';
import { getTitle, getContent } from '../../store/reducers/pages';
import ActionButton from '../ActionButton';
import BasePage from './BasePage';
import StyledEditor from './StyledEditor';

class Show extends React.Component {
  componentWillMount() {
    this.props.fetchPage(this.props.params.pageId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.pageId !== this.props.params.pageId) {
      this.props.fetchPage(nextProps.params.pageId);
    }
  }

  render() {
    const {title, content, params: {pageId}} = this.props;

    if (!content) {
      return <p>Loading...</p>
    }

    const editorState = EditorState.createWithContent(content);

    const links = [
      <ActionButton>
        <Link to={`/pages/${pageId}/edit`}>Edit</Link>
      </ActionButton>
    ];

    return (
      <BasePage title={title} links={links}>
        <StyledEditor editorState={editorState} readOnly={true} />
      </BasePage>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    title: getTitle(state.pages, ownProps.params.pageId),
    content: getContent(state.pages, ownProps.params.pageId)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPage: pageId => dispatch({ type: FETCH_PAGE, pageId })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Show);


/** WEBPACK FOOTER **
 ** ./src/components/pages/Show.js
 **/